// extracted by mini-css-extract-plugin
export default {"cardAccordionHeader":"AccordionToggle_cardAccordionHeader__AhTxm","accordion":"AccordionToggle_accordion__yG5vg"};